// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SuitableConnectionsSetVO')
export class SuitableConnectionsSetVO {

  @JsonProperty('searchVectorId', 'Number')
  public searchVectorId: number = undefined;
  @JsonProperty('connectionNames', '[String]')
  public connectionNames: string[] = undefined;
  @JsonProperty('matchingRequirementIndices', '[Number]')
  public matchingRequirementIndices: number[] = undefined;
}
